/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useProfile } from 'hooks';
import { LanguageUpdateForm, TimezoneUpdateForm } from 'components/modules';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function AccountSettings() {
  const classes = useStyles(Styles);
  const { data: profile, updateUserProfile } = useProfile();

  return (
    <div className={classes.userAccountWrapper}>
      <LanguageUpdateForm formId="languageUpdateForm" onSubmit={updateUserProfile} {...profile} />
      <TimezoneUpdateForm formId="timezoneUpdateForm" onSubmit={updateUserProfile} {...profile} />
    </div>
  );
}

export default AccountSettings;
